import Swal from 'sweetalert2'

export function $swal(params) {
  return Swal.fire(params)
}

export function $popSwal(icon:string,title:string,text:string|null) {
  if(icon=="success"){
    $swal({
      position: 'top-end',
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    });
  }else if (icon=="error"){
    $swal({
      position: 'top-end',
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: false,
      // timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    });
  }else{
    $swal({
      position: 'top-end',
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: false,
      // timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    });
  }
}

export function $showSnackbar(color:string|null="success",text:string|null="成功",timeout:number|null=3000) {
  let timer:number|null=null
  if(!!timeout){
    timer = timeout
  }else{
    if(color=="error"){
      timer = -1
    }else{
      timer = 3000
    }
  }
  return {
    show: true,
    color: color,
    text: text,
    timeout: timer
  }
}
